import {
    BriefcaseBusiness,
    FolderOpen,
    LucideIcon,
    UserCog,
} from 'lucide-react';

import { UserRole } from '@/api/auth/auth.models';
import { useAuthStatus } from '@/hooks/useAuthStatus';

export interface SidebarMenuItem {
    label: string;
    icon: LucideIcon;
    href: string;
    onClick?: () => void;
    children?: SidebarMenuItem[];
    visible?: boolean;
}

export const useSidebarMenu = () => {
    const { data: authStatus, isLoading } = useAuthStatus();
    const roles = authStatus?.roles ?? [];

    const isUserInAllowedRole = (allowedRoles: UserRole[]) => {
        return allowedRoles.some((role) => roles.includes(role));
    };

    const menu: SidebarMenuItem[] = isLoading
        ? []
        : [
              {
                  label: 'Customers',
                  icon: BriefcaseBusiness,
                  href: '/customers',
                  visible: isUserInAllowedRole([UserRole.Admin]),
              },
              {
                  label: 'Projects',
                  icon: FolderOpen,
                  href: '/projects',
                  visible: isUserInAllowedRole([UserRole.CustomerAdmin]),
              },
              {
                  label: 'Operatives',
                  icon: UserCog,
                  href: '/operatives',
                  visible: isUserInAllowedRole([UserRole.CustomerAdmin]),
              },
          ];
    return {
        menu,
        isLoading,
    };
};
